import { Link } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import { useOpenClientDownload } from '@/shared/hooks/useClientDownload';

/** Faixa panoramica final "Sua lenda comeca aqui" (id=download). */
export function CtaWide() {
  const { isLoggedIn } = useAuth();
  const openDownload = useOpenClientDownload();
  return (
    <section className="cta-wide" id="download">
      <div className="cta-wide-media" aria-hidden="true"></div>
      <div className="cta-wide-shade" aria-hidden="true"></div>
      <div className="shell cta-wide-inner reveal">
        <div className="cta-copy">
          <span className="cta-eyebrow">Uma nova jornada em Nevareth</span>
          <h2>Sua lenda<br /><span>começa aqui</span></h2>
          <p>Junte-se a milhares de jogadores em uma nova jornada por Nevareth.<br />Liberdade, desafio e um mundo inteiro para explorar.</p>
        </div>
        <div className="cta-actions">
          <Link className="btn btn-gold btn-big" to={isLoggedIn ? '/dashboard' : '/cadastro'}>♙ Jogar agora</Link>
          <button className="btn btn-silver btn-big" onClick={openDownload}>⇩ Baixar cliente</button>
        </div>
      </div>
    </section>
  );
}
